<template>
  <ion-page class="cut-box">
    <common-background
      :title="'快闪魔方第' + step + '组'"
      router-type="modal"
      @router-back="onConfirmCloseWrap"
    >
      <template #default>
        <div v-show="!showButtons" class="cut-box_page">
          <VideoHeight />
          <div v-if="dataList?.length" class="word-list">
            <template v-for="(item, index) in dataList" :key="index">
              <div
                v-if="item.isShow"
                class="word-list_item flex-row justify-between"
                @click="onShowParaphrase(index, item, $event)"
              >
                <div class="item-word flex-row align-center flex-wrap">
                  <span
                    v-show="!item.showParaphrase"
                    class="word-style switch-font-size-video flex-row align-center mr-5"
                  >
                    {{ item.word }}
                  </span>
                  <div
                    v-show="item.showParaphrase"
                    class="cnword word-style gray-color flex-row flex-wrap"
                  >
                    <span class="english-word switch-font-size-video">{{ item.word }}</span
                    ><span>{{ item.paraphrase }}</span>
                  </div>
                </div>
                <div class="item-icon flex-row align-center">
                  <img
                    v-if="item?.audioIconShow || (!showButtons && showOneButton)"
                    class="mr-4 img-icon cursor-pointer"
                    src="@/assets/teacher_index/version5/teacher_button.png"
                    @click.stop="
                      playUniversalFormulaAudioWrap(
                        item.word,
                        item.paraphrase,
                        50 * speedRate,
                        index
                      )
                    "
                  />
                  <!--  :src="getBrandImageUrl('speed/cut_box_button.png')"-->
                  <div v-if="showOneButton" @click.stop="onSelect2(index, item)">
                    <img
                      class="test-icon cursor-pointer"
                      src="@/assets/teacher_index/version5/scissors_right.svg"
                      alt=""
                    />
                  </div>

                  <div v-if="!showOneButton" @click.stop="onYes2(index, item)">
                    <img
                      class="test-icon mr-4 cursor-pointer"
                      src="@/assets/teacher_index/version5/scissors_right.svg"
                      alt=""
                    />
                  </div>

                  <div v-if="!showOneButton" @click.stop="onNot(index, item)">
                    <img
                      class="test-icon cursor-pointer"
                      src="@/assets/teacher_index/version5/scissors_mistake.svg"
                      alt=""
                    />
                  </div>

                  <!--                      两英一汉发音-->
                  <!--                <img-->
                  <!--                     v-if="!showButtons && showOneButton"-->
                  <!--                    class="test-icon ml-4"-->
                  <!--                    :src="getBrandImageUrl('speed/two_one.png')"-->
                  <!--                    alt=""-->
                  <!--                    @click.stop="playAudio(item)"-->
                  <!--                />-->
                </div>
              </div>
            </template>
          </div>
          <div v-else class="cut-box-empty">
            <!--              <div class="cut-box-empty-tip" :class="{'onlyNotNumClass': selectNotNum && !selectYesNum}">-->
            <!--                <div class="cut-box-empty-tip__title">点击继续</div>-->
            <!--                <img class="cut-box-empty-tip__img" :src="getBrandImageUrl('speed/green_down_icon.png')" alt="点击继续">-->
            <!--              </div>-->
            <!--              <div v-show="selectNotNum" class="cut-box-empty-tip notNumClass">-->
            <!--                <div class="cut-box-empty-tip__title">点击继续</div>-->
            <!--                <img class="cut-box-empty-tip__img" :src="getBrandImageUrl('speed/red_down_icon.png')" alt="点击继续">-->
            <!--              </div>-->
          </div>
        </div>
        <div
          v-show="showButtons"
          class="cut-box_page encourage-padding flex-column justify-between"
        >
          <div class="emoji flex-column align-center">
            <img :src="getBrandImageUrl('speed/encourage_bg.png')" alt="" />
          </div>
          <div class="flex-column">
            <ion-button class="button-outline mb-3" shape="round" @click="onReCheck"
              >重新检查
            </ion-button>
            <ion-button
              v-show="!isEnd && !needMixture"
              class="green_bg mb-3"
              shape="round"
              @click="backSign"
              >下一组
            </ion-button>
            <ion-button
              v-show="needMixture"
              class="green_bg mb-3"
              shape="round"
              @click="openMixture(step)"
              >混组检查
            </ion-button>
            <ion-button
              v-show="isEnd && !needMixture"
              class="green_bg mb-3"
              shape="round"
              @click="openMixture(10)"
              >全部混组
            </ion-button>
          </div>
        </div>
      </template>
      <template #rightTitle>
        <switch-font-size />
        <speed-switch :pause-show="true" :pause-flag="pauseFlag" @onPauseClass="onPauseClass" />
      </template>
    </common-background>
    <div v-show="!showButtons" class="cut-box_bottom">
      <div class="cut-box_bottom-content flex-row justify-evenly align-center">
        <div v-show="showOneButton" class="cut-box_box" @click="onRestore">
          <img
            v-show="selectNum === 0"
            src="@/assets/teacher_index/version5/empty_green_box.svg"
            alt=""
          />
          <img
            v-show="selectNum !== 0"
            src="@/assets/teacher_index/version5/fill_green_box.svg"
            alt=""
          />
          <span class="box-text true-text">{{ selectNum }}</span>
        </div>
        <div
          v-show="!showOneButton && selectYesNum === 0"
          class="cut-box_box"
          @click="onYesRestore"
        >
          <img src="@/assets/teacher_index/version5/empty_green_box.svg" alt="" />
          <span class="box-text true-text">{{ selectYesNum }}</span>
        </div>
        <div
          v-show="!showOneButton && selectYesNum !== 0"
          class="cut-box_box"
          @click="onYesRestore"
        >
          <img src="@/assets/teacher_index/version5/fill_green_box.svg" alt="" />
          <span class="box-text true-text">{{ selectYesNum }}</span>
        </div>
        <div
          v-show="!showOneButton && selectNotNum === 0"
          class="cut-box_box"
          @click="onNotRestore"
        >
          <img src="@/assets/teacher_index/version5/empty_red_box.svg" alt="" />
          <span class="box-text false-text">{{ selectNotNum }}</span>
        </div>
        <div
          v-show="!showOneButton && selectNotNum !== 0"
          class="cut-box_box"
          @click="onNotRestore"
        >
          <img src="@/assets/teacher_index/version5/fill_red_box.svg" alt="" />
          <span class="box-text common-red-color false-text">{{ selectNotNum }}</span>
        </div>
      </div>
    </div>
  </ion-page>
</template>

<script>
import { alertController, IonButton, IonPage, modalController } from "@ionic/vue"

import {
  arrowBackCircle,
  arrowForwardCircle,
  arrowUndo,
  checkmarkCircle,
  chevronBackOutline,
  closeCircle,
  gitCompare,
  pause,
  reorderFour,
} from "ionicons/icons"
import store from "@/js/store"
import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages.ts"
import CommonBackground from "@/components/CommonBackground.vue"
import { playUniversalFormulaAudio } from "@/js/commonMethod"
import SpeedSwitch from "@/components/speedSwitch.vue"
import { useStorage } from "@vueuse/core"
import mqttServer from "@/js/mqtt"
import pagesQueue from "@/js/pagesQueue"
import PageDialog from "@/components/PageDialog.vue"
import VideoHeight from "@/views/liveVideo/components/videoHeight.vue"
import SwitchFontSize from "@/views/liveVideo/components/switchFontSize.vue"

const speedRate = useStorage("xf-speed", 1, localStorage)
export default {
  name: "SpeedCutBox",
  components: {
    SpeedSwitch,
    CommonBackground,
    IonPage,
    IonButton,
    VideoHeight,
    SwitchFontSize,
  },
  props: ["studentId", "step"],
  setup() {
    return {
      pause,
      checkmarkCircle,
      closeCircle,
      chevronBackOutline,
      gitCompare,
      arrowUndo,
      reorderFour,
      arrowBackCircle,
      arrowForwardCircle,
      speedRate,
    }
  },

  data() {
    return {
      instructData: {
        project: "lxll",
        page: "teachIndex",
        module: "CutBox",
        pageModle: true,

        userType: 1,
        data: null,
        fn: "",
        param: null,
        timestamp: " ",
      },
      dataList: [],
      historySelectList: [], // 巡查官使用该数组确保展示同步
      historySelectListYes: [], // 巡查官使用该数组确保展示同步-选择yes的单词
      historySelectListNot: [], // 巡查官使用该数组确保展示同步-选择no的单词
      showButtons: false, //剪纸盒步骤
      showOneButton: true, //混组检查第一步
      isEnd: false, //控制"混组全部"按钮显示
      isOver: false, //控制"全部结束"按钮显示
      selectItems: [],
      selectYesItems: [],
      selectNotItems: [],
      selectNum: 0,
      selectYesNum: 0,
      selectNotNum: 0,
      pauseFlag: false, //是否暂停过标记
      brandImages: BRAND_IMAGES,
      mixtureModal: null,
      clockTimer1: undefined,
      clockTimer2: undefined,
      remainingTime: undefined, //剩余时间
    }
  },

  computed: {
    //计算当前步骤是否需要混组
    needMixture() {
      if (this.step == 1 || this.step == 4 || this.step == 7) {
        return false
      } else {
        return true
      }
    },
  },
  watch: {
    // mixtureModal() {
    //   if (this.mixtureModal) {
    //     this.listenModalDismiss()
    //   }
    // },
  },

  async mounted() {
    // sessionStorage.setItem('pageFlag','false')
    mqttServer.onMqttMessage(this.instructData.module, this.onMessageReceived)
    this.userinfo = this.store.getUser()
    this.getPauseStatus() //读取暂停状态
    if (this.dataList.length == 0) {
      this.queryVocabulary()
    } else {
      setTimeout(() => {
        sessionStorage.setItem("pageFlag", "true")
      })
    }
  },

  methods: {
    playUniversalFormulaAudioWrap(word, paraphrase, speedRate, idx) {
      mqttServer
        .pushMsg(this.instructData, {
          params: [word, paraphrase, speedRate, idx],
          fn: "playUniversalFormulaAudio",
          msgType: "function",
        })
        .then(async () => {
          this.playUniversalFormulaAudio(word, paraphrase, speedRate, idx)
          // this.autoShowClickGifSync(idx)
        })
    },

    onConfirmCloseWrap() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "onConfirmCloseSync",
          msgType: "function",
        })
        .then(async () => {
          this.onConfirmCloseSync()
        })
    },
    async onConfirmCloseSync() {
      const modal = await modalController.create({
        component: PageDialog,
        id: "PageDialog",
        backdropDismiss: false,
        componentProps: { message: "确认回退吗?", type: "hasCancel" },
        cssClass: "center_modal_controller_class3",
      })
      await modal.present()
      const { data } = await modal.onDidDismiss()
      if ("NEXT" === data) {
        modalController.dismiss()
        pagesQueue.queuePageChange("Nine")
      }
    },
    // 关闭提示弹框
    cancelAlrtController() {
      alertController.dismiss()
    },

    // 关闭模态弹框
    cancelModel() {
      pagesQueue.queuePagePop()
      modalController.dismiss()
    },
    playUniversalFormulaAudio,
    getBrandImageUrl,
    routerBack() {
      modalController.dismiss()
    },

    // 关闭提示弹框和模态弹框
    cancelAllModel() {
      this.cancelAlrtController()
      this.cancelModel()
    },

    // 处理消息
    async onMessageReceived(msg) {
      // 确保 msg.fn 是 this 上的有效函数
      if (typeof this[msg.fn] !== "function") {
        throw new Error(`Method ${msg.fn} is not a function`)
      }

      try {
        // 根据 params 是否为数组决定如何调用方法
        if (Array.isArray(msg.params)) {
          await this[msg.fn](...msg.params)
        } else {
          await this[msg.fn](msg.params)
        }
        return true
      } catch (error) {
        console.error("Error executing method:", error)
        throw error // 或者根据需要处理错误
      }
    },

    backSign() {
      mqttServer
        .pushMsg(this.instructData, {
          params: [],
          fn: "backSignSync",
          msgType: "function",
        })
        .then(async () => {
          pagesQueue.queuePageChange("Sign", {
            studentId: this.studentId,
            step: this.step + 1,
          })
        })
    },

    backSignSync() {
      this.currentStep++
      pagesQueue.queuePageChange("Sign", {
        studentId: this.studentId,
        step: this.step + 1,
      })
    },

    //混组检查异步
    async openMixtureSync(step) {
      // sessionStorage.setItem('pageFlag','false')

      pagesQueue.queuePagePush({
        page: "Mixture",
        params: { studentId: this.studentId, step: step },
      })
      //this.showButtons = false;
      // useMsgStore().setComponentOptions({
      //   component: Mixture,
      //   componentProps: { studentId: this.studentId, step: step },
      // })
      // const modal = await modalController.create({
      //   component: Mixture,
      //   componentProps: { studentId: this.studentId, step: step },
      //   cssClass: "modal_controller_class",
      // })
      //
      // await modal.present()
      // const { data } = await modal.onDidDismiss()
      // console.log("cutbox1", data)
      // if (data) {
      //   await modalController.dismiss({ ...data })
      // }
    },

    //混组检查
    async openMixture(step) {
      mqttServer
        .pushMsg(this.instructData, {
          params: [step],
          fn: "openMixtureSync",
          msgType: "function",
        })
        .then(async () => {
          this.openMixtureSync(step)
        })
    },

    //重新检查
    onReCheckSync() {
      if (
        this.selectYesItems.length > 0 &&
        this.dataList.filter((item) => item.isShow).length == 0
      ) {
        for (let i = 0; i < this.dataList.length; i++) {
          this.dataList[i]["audioIconShow"] = false
          this.dataList[i].isShow = true
        }
        this.showButtons = false //剪纸盒步骤
        this.selectItems = []
        this.selectYesItems = []
        this.selectNotItems = []
        this.selectNum = 0
        this.selectYesNum = 0
        this.selectNotNum = 0
        this.historySelectList = []
        this.historySelectListYes = []
        this.historySelectListNot = []
      }
    },

    //重新检查
    onReCheck() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "onReCheckSync",
          msgType: "function",
        })
        .then(() => {
          this.onReCheckSync()
        })
    },

    //点击中间盒子,释放单词异步-第一步-点击绿剪刀图标
    onRestoreSync(adminPass, historySelectList = [], isShowParaphraseIndex = []) {
      if (this.userinfo.isAdmin && historySelectList.length > 0) {
        // 根据onSelect2List的索引，把dataList中isShow为false的单词的showParaphrase设置为false，clickStep设置为1
        for (let i = 0; i < historySelectList.length - 1; i++) {
          if (this.dataList[historySelectList[i]].isShow) {
            this.dataList[historySelectList[i]].showParaphrase = false
            this.dataList[historySelectList[i]].clickStep = 1
            this.selectItems.push(this.dataList[historySelectList[i]])
            this.selectNum++
            this.dataList[historySelectList[i]].isShow = false
          }
        }
        if (isShowParaphraseIndex.length > 0) {
          isShowParaphraseIndex.forEach((index) => {
            this.dataList[index].isShow = true
            this.dataList[index].clickStep = 3
            this.dataList[index].showParaphrase = true
            this.selectItems.forEach((item) => {
              if (item.vocabularyId == this.dataList[index].vocabularyId) {
                this.selectItems.splice(this.selectItems.indexOf(item), 1)
              }
            })
          })
          this.selectNum = this.selectItems.length
        }
      }
      if (this.userinfo.isAdmin && adminPass && this.selectItems.length == 0) {
        for (let i = 0; i < this.dataList.length; i++) {
          if (this.dataList[i].isShow) {
            this.dataList[i].showParaphrase = false
            this.dataList[i].clickStep = 1
            this.dataList[i].isShow = false
            this.selectItems.push(this.dataList[i])
          }
        }
        this.selectNum = this.selectItems.length
      }
      if (this.selectItems.length > 0 && this.dataList.filter((item) => item.isShow).length == 0) {
        this.showOneButton = false
        for (let i = 0; i < this.dataList.length; i++) {
          this.dataList[i].isShow = true
          this.dataList[i].clickStep = 1
          this.dataList[i].showParaphrase = false
        }
        this.selectItems = []
        this.selectNum = 0
        this.historySelectList = []
        this.historySelectListYes = []
        this.historySelectListNot = []
      }
    },

    //点击中间盒子,释放单词
    onRestore() {
      const adminPass =
        this.selectItems.length > 0 && this.dataList.filter((item) => item.isShow).length == 0
      const isShowParaphraseIndex = []
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].isShow && this.dataList[i].showParaphrase) {
          isShowParaphraseIndex.push(i)
        }
      }
      mqttServer
        .pushMsg(this.instructData, {
          params: [adminPass, this.historySelectList, isShowParaphraseIndex],
          fn: "onRestoreSync",
          msgType: "function",
        })
        .then(() => {
          this.onRestoreSync()
        })
    },

    //点击左边盒子,释放单词异步
    onYesRestoreSync(historySelectListYes = [], historySelectListNot = []) {
      if (this.userinfo.isAdmin) {
        this.showOneButton = false
        if (historySelectListYes.length > 0 && this.selectYesItems.length == 0) {
          for (let i = 0; i < historySelectListYes.length; i++) {
            if (this.dataList[historySelectListYes[i]].clickStep == 1) {
              this.dataList[historySelectListYes[i]].showParaphrase = false
              this.dataList[historySelectListYes[i]].clickStep = 1
              this.dataList[historySelectListYes[i]]["audioIconShow"] = false
              this.selectYesItems.push(this.dataList[historySelectListYes[i]])
              this.dataList[historySelectListYes[i]].isShow = false
            }
          }
          this.selectYesNum = this.selectYesItems.length
        }
        if (historySelectListNot.length > 0 && this.selectNotItems.length == 0) {
          for (let i = 0; i < historySelectListNot.length; i++) {
            this.dataList[historySelectListNot[i]].showParaphrase = false
            this.selectNotItems.push(this.dataList[historySelectListNot[i]])
            this.dataList[historySelectListNot[i]].isShow = false
          }
          this.selectNotNum = this.selectNotItems.length
        }
      }
      if (this.selectYesItems.length > 0) {
        for (let i = 0; i < this.dataList.length; i++) {
          if (
            this.dataList[i].vocabularyId ==
            this.selectYesItems[this.selectYesItems.length - 1].vocabularyId
          ) {
            this.dataList[i].audioIconShow = false
            this.dataList[i].isShow = true
            this.dataList[i].clickStep = 1
            this.selectYesItems.pop()
            this.historySelectListYes.pop()
            break
          }
        }
        this.selectYesNum = this.selectYesItems.length
      }
    },

    //点击左边盒子,释放单词
    onYesRestore() {
      mqttServer
        .pushMsg(this.instructData, {
          params: [this.historySelectListYes, this.historySelectListNot],
          fn: "onYesRestoreSync",
          msgType: "function",
        })
        .then(() => {
          this.onYesRestoreSync()
        })
    },

    //点击右边盒子,释放单词
    onNotRestoreSync(historySelectListNot = [], historySelectListYes = []) {
      if (this.userinfo.isAdmin) {
        // 如果是巡查官登录，当陪练进行到该步骤时要变更巡查官的步骤按钮状态
        this.showOneButton = false
        if (historySelectListNot.length > 0 && this.selectNotItems.length == 0) {
          for (let i = 0; i < historySelectListNot.length; i++) {
            this.dataList[historySelectListNot[i]].showParaphrase = false
            this.selectNotItems.push(this.dataList[historySelectListNot[i]])
            this.selectNotNum = this.selectNotItems.length
            // this.dataList.splice(index, 1)
            this.dataList[historySelectListNot[i]].isShow = false
          }
        }
        if (historySelectListYes.length > 0 && this.selectYesItems.length == 0) {
          for (let i = 0; i < historySelectListYes.length; i++) {
            if (this.dataList[historySelectListYes[i]].clickStep == 1) {
              this.dataList[historySelectListYes[i]].showParaphrase = false
              this.dataList[historySelectListYes[i]].clickStep = 1
              this.dataList[historySelectListYes[i]]["audioIconShow"] = false
              this.selectYesItems.push(this.dataList[historySelectListYes[i]])
              this.dataList[historySelectListYes[i]].isShow = false
            }
          }
          this.selectYesNum = this.selectYesItems.length
        }
      }
      if (this.selectNotItems.length > 0) {
        for (let i = 0; i < this.dataList.length; i++) {
          for (let j = 0; j < this.selectNotItems.length; j++) {
            if (this.dataList[i].vocabularyId == this.selectNotItems[j].vocabularyId) {
              this.dataList[i].isShow = true
              this.dataList[i].audioIconShow = true
              this.dataList[i].clickStep = 1
            }
          }
        }
        this.selectNotItems = []
        this.historySelectListNot = []
        this.selectNotNum = this.selectNotItems.length
      }
    },

    //点击右边盒子,释放单词
    onNotRestore() {
      mqttServer
        .pushMsg(this.instructData, {
          params: [this.historySelectListNot, this.historySelectListYes],
          fn: "onNotRestoreSync",
          msgType: "function",
        })
        .then(() => {
          this.onNotRestoreSync()
        })
    },

    onSelect2Sync(index, item, historySelectList = [], isShowParaphraseIndex = []) {
      const currentItem = this.dataList[index]
      if (!currentItem) return

      if (this.userinfo.isAdmin && historySelectList.length > 0) {
        // 根据onSelect2List的索引，把dataList中isShow为false的单词的showParaphrase设置为false，clickStep设置为1
        for (let i = 0; i < historySelectList.length - 1; i++) {
          if (this.dataList[historySelectList[i]].isShow) {
            this.dataList[historySelectList[i]].showParaphrase = false
            this.dataList[historySelectList[i]].clickStep = 1
            this.selectItems.push(this.dataList[historySelectList[i]])
            this.selectNum++
            this.dataList[historySelectList[i]].isShow = false
          }
        }
        if (isShowParaphraseIndex.length > 0) {
          isShowParaphraseIndex.forEach((index) => {
            this.dataList[index].isShow = true
            this.dataList[index].clickStep = 3
            this.dataList[index].showParaphrase = true
            this.selectItems.forEach((item) => {
              if (item.vocabularyId == this.dataList[index].vocabularyId) {
                this.selectItems.splice(this.selectItems.indexOf(item), 1)
              }
            })
          })
          this.selectNum = this.selectItems.length
        }
        this.dataList[index] = item
        //第一遍只发音
        if (item.clickStep == 1) {
          item["playbackRate"] = speedRate.value
          this.playSoundTemp(item)
          item.showParaphrase = true
          item.clickStep = 3
        }

        //第三遍消失
        else if (item.clickStep == 3) {
          item.showParaphrase = false
          item.clickStep = 1
          this.selectItems.push(item)
          this.selectNum++
          // this.dataList.splice(index, 1)
          item.isShow = false
          this.audio(this.voice_path + "right.mp3")
        }
      } else {
        //第一遍只发音
        if (currentItem.clickStep == 1) {
          currentItem["playbackRate"] = speedRate.value
          item["playbackRate"] = speedRate.value
          this.playSoundTemp(item)
          currentItem.showParaphrase = true
          currentItem.clickStep = 3
        }

        //第三遍消失
        else if (currentItem.clickStep == 3) {
          currentItem.showParaphrase = false
          currentItem.clickStep = 1
          const isDuplicate = this.selectItems.some(
            (item) => item.vocabularyId == currentItem.vocabularyId
          )
          if (!isDuplicate) {
            this.selectItems.push(currentItem)
          }
          this.selectNum = this.selectItems.length
          // this.dataList.splice(index, 1)
          this.dataList[index].isShow = false
          this.dataList[index].clickStep = 1
          this.audio(this.voice_path + "right.mp3")
        }
      }
    },

    //自动带读模式，第一遍学习每个单词需要点击三次
    //第一遍打钩  重写，2024-02-27
    //点击3次，第一次只发音，第二次显示中英文，第三次消失
    onSelect2(index, item) {
      const isShowParaphraseIndex = []
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].isShow && this.dataList[i].showParaphrase) {
          isShowParaphraseIndex.push(i)
        }
      }
      // 去重
      this.historySelectList.push(index)
      this.historySelectList = [...new Set(this.historySelectList)]
      try {
        mqttServer
          .pushMsg(this.instructData, {
            params: [index, item, this.historySelectList, isShowParaphraseIndex],
            fn: "onSelect2Sync",
            msgType: "function",
          })
          .then(() => {
            this.onSelect2Sync(index, item)
          })
      } catch {
        this.historySelectList.pop()
      }
    },

    onYes2Sync(index, item, historySelectListYes = [], historySelectListNot = []) {
      const currentItem = this.dataList[index]
      if (this.userinfo.isAdmin) {
        this.showOneButton = false
        if (historySelectListYes.length > 0 && this.selectYesItems.length == 0) {
          for (let i = 0; i < historySelectListYes.length - 1; i++) {
            if (this.dataList[historySelectListYes[i]].clickStep == 1) {
              this.dataList[historySelectListYes[i]].showParaphrase = false
              this.dataList[historySelectListYes[i]].clickStep = 1
              this.dataList[historySelectListYes[i]]["audioIconShow"] = false
              this.selectYesItems.push(this.dataList[historySelectListYes[i]])
              this.selectYesNum = this.selectYesItems.length
              // this.dataList.splice(index, 1)
              this.dataList[historySelectListYes[i]].isShow = false
            }
          }
        }
        if (historySelectListNot.length > 0 && this.selectNotItems.length == 0) {
          for (let i = 0; i < historySelectListNot.length; i++) {
            this.dataList[historySelectListNot[i]].showParaphrase = false
            this.selectNotItems.push(this.dataList[historySelectListNot[i]])
            this.selectNotNum = this.selectNotItems.length
            // this.dataList.splice(index, 1)
            this.dataList[historySelectListNot[i]].isShow = false
          }
        }
      }
      //第一遍只发音
      if (currentItem.clickStep == 1) {
        // item["playbackRate"] = speedRate.value;
        // this.playSoundTemp(item);
        currentItem.showParaphrase = false
        currentItem.clickStep = 1
        currentItem["audioIconShow"] = false
        const isDuplicate = this.selectYesItems.some(
          (item) => item.vocabularyId == currentItem.vocabularyId
        )
        if (!isDuplicate) {
          this.selectYesItems.push(currentItem)
        }
        this.selectYesNum = this.selectYesItems.length
        // this.dataList.splice(index, 1)
        this.dataList[index].isShow = false
        this.dataList[index].clickStep = 1
        this.audio(this.voice_path + "right.mp3")
        if (
          this.dataList.filter((item) => item.isShow).length == 0 &&
          this.selectNotItems.length == 0
        ) {
          this.showButtons = true //混组检查
        }
      }
    },

    onYes2(index, item) {
      // 检查historySelectListNot中是否包含当前单词的index,如果存在则不添加到historySelectListYes中
      const isDuplicate = this.historySelectListNot.some((item) => item == index)
      if (isDuplicate) {
        return
      }
      this.historySelectListYes.push(index)
      this.historySelectListYes = [...new Set(this.historySelectListYes)]
      try {
        mqttServer
          .pushMsg(this.instructData, {
            params: [index, item, this.historySelectListYes, this.historySelectListNot],
            fn: "onYes2Sync",
            msgType: "function",
          })
          .then(() => {
            this.onYes2Sync(index, item)
          })
      } catch {
        this.historySelectListYes.pop()
      }
    },

    //打叉异步
    onNotSync(index, item, historySelectListNot = [], historySelectListYes = []) {
      const currentItem = this.dataList[index]
      if (this.userinfo.isAdmin) {
        this.showOneButton = false
        if (historySelectListNot.length > 0 && this.selectNotItems.length == 0) {
          for (let i = 0; i < historySelectListNot.length - 1; i++) {
            this.dataList[historySelectListNot[i]].showParaphrase = false
            this.selectNotItems.push(this.dataList[historySelectListNot[i]])
            this.selectNotNum = this.selectNotItems.length
            // this.dataList.splice(index, 1)
            this.dataList[historySelectListNot[i]].isShow = false
          }
        }
        if (historySelectListYes.length > 0 && this.selectYesItems.length == 0) {
          for (let i = 0; i < historySelectListYes.length; i++) {
            if (this.dataList[historySelectListYes[i]].clickStep == 1) {
              this.dataList[historySelectListYes[i]].showParaphrase = false
              this.dataList[historySelectListYes[i]].clickStep = 1
              this.dataList[historySelectListYes[i]]["audioIconShow"] = false
              this.selectYesItems.push(this.dataList[historySelectListYes[i]])
              this.selectYesNum = this.selectYesItems.length
              // this.dataList.splice(index, 1)
              this.dataList[historySelectListYes[i]].isShow = false
            }
          }
        }
      }
      currentItem.showParaphrase = false
      const isDuplicate = this.selectNotItems.some(
        (item) => item.vocabularyId == currentItem.vocabularyId
      )
      if (!isDuplicate) {
        this.selectNotItems.push(currentItem)
      }
      this.selectNotNum = this.selectNotItems.length
      // this.dataList.splice(index, 1)
      this.dataList[index].isShow = false
      this.audio(this.voice_path + "err.mp3")
    },

    //打叉
    onNot(index, item) {
      // 检查historySelectListYes中是否包含当前单词的index,如果存在则不添加到historySelectListNot中
      const isDuplicate = this.historySelectListYes.some((item) => item == index)
      if (isDuplicate) {
        return
      }
      this.historySelectListNot.push(index)
      this.historySelectListNot = [...new Set(this.historySelectListNot)]
      try {
        mqttServer
          .pushMsg(this.instructData, {
            params: [index, item, this.historySelectListNot, this.historySelectListYes],
            fn: "onNotSync",
            msgType: "function",
          })
          .then(() => {
            this.onNotSync(index, item)
          })
      } catch {
        this.historySelectListNot.pop()
      }
    },

    //点击单词,显示释义
    onShowParaphraseSync(index, item, playSW) {
      item["playbackRate"] = speedRate.value
      this.playSoundTemp(item)

      for (let i = 0; i < this.dataList.length; i++) {
        if (index == i) {
          item["checked"] = true
          this.dataList[i].showParaphrase = !item.showParaphrase
        } else {
          item["checked"] = false
          this.dataList[i].showParaphrase = false
        }
      }
    },

    //点击单词,显示释义
    onShowParaphrase(index, item, playSW) {
      const showParaphrase = this.dataList.filter((k) => k.vocabularyId == item.vocabularyId)[0]
        .showParaphrase
      mqttServer
        .pushMsg(this.instructData, {
          params: [index, item, showParaphrase],
          fn: "onShowParaphraseSync",
          msgType: "function",
        })
        .then(() => {
          this.onShowParaphraseSync(index, item, showParaphrase)
        })
    },

    randomSort(list) {
      //仅对元素个数大于2个的数组进行打乱
      if (list.length < 2) {
        return
      }

      const list2 = list.slice(0)

      list.sort(function () {
        return 0.5 - Math.random()
      })

      let sameNum = 0
      for (let i = 0; i < list.length; i++) {
        if (list[i] == list2[i]) {
          sameNum++
        }
      }

      if (sameNum >= 2) {
        this.randomSort(list)
      }
    },

    queryVocabularySync(res, ev) {
      const page = res.data.page
      const list = page.list

      if (page.isLastPage) {
        this.isEnd = true
      }

      if (list) {
        //打乱顺序
        // this.randomSort(list);
        // if (this.userinfo.userType == "2") {

        //   mqttServer.pushMsg(this.instructData, {
        //     params: [ev, { list: this.dataList, isEnd: this.isEnd }],
        //     fn: "queryVocabulary",
        //     msgType: "function",
        //   })
        // }

        for (let i = 0; i < list.length; i++) {
          list[i].isShow = true
          list[i].status = 1
          list[i].showParaphrase = false
          list[i].clickStep = 1 //自动带读，需要点击3次，分别对于不同处理逻辑
        }
        this.dataList = list

        sessionStorage.setItem("pageFlag", "true")
      }

      //关闭刷新等待动画
      if (ev) {
        ev.target.complete()
      }
    },

    //查询需要练习的词汇
    queryVocabulary(ev) {
      this.ajax
        .post("/vocabulary/queryCurrentWords", {
          studentId: this.studentId,
          pageNum: this.step,
        })
        .then((res) => {
          // mqttServer
          //   .pushMsg(this.instructData, {
          //     params: [res, ev],
          //     fn: "queryVocabularySync",
          //     msgType: "function",
          //   })
          //   .then(() => {
          //   })
          this.queryVocabularySync(res, ev)
        })
    },

    doRefresh(RefreshAnimationEvent) {
      this.tools.closeRefreshAnimation(RefreshAnimationEvent, 2000)
      this.queryVocabulary(RefreshAnimationEvent)

      //重置状态
      this.selectItems = []
      this.selectYesItems = []
      this.selectNotItems = []
      this.selectNum = 0
      this.selectYesNum = 0
      this.selectNotNum = 0
      this.historySelectList = []
      this.historySelectListYes = []
      this.historySelectListNot = []
    },

    //点击暂停按钮 异步
    onPauseClassSync() {
      const that = this
      const appointment = store.getAppointment()
      if (appointment == null) {
        that.alert("获取当前正在练习的资料信息失败。")
      } else {
        that.ajax.get("/record/pauseClass?aptmId=" + appointment.aptmId).then((res) => {
          if (res.data.success) {
            that.pauseFlag = true
            that.alert("本次训练暂停5分钟")
          }
        })
      }
    },

    //点击暂停按钮
    onPauseClass() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "onPauseClassSync",
          msgType: "function",
        })
        .then(() => {
          this.onPauseClassSync()
        })
    },

    //读取暂停状态
    getPauseStatus() {
      const that = this
      const appointment = store.getAppointment()
      if (appointment == null) {
        that.alert("获取当前正在练习的资料信息失败。")
      } else {
        that.ajax.get("/record/getPauseStatus?aptmId=" + appointment.aptmId).then((res) => {
          if (res.data.success) {
            if (res.data.data && res.data.data.pause == 1) {
              that.pauseFlag = true
            }
          }
        })
      }
    },
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";
@import "@/styles/variables.less";

.cut-box {
  width: 100%;
  height: 100%;
  position: relative;
  user-select: none;
  -webkit-user-select: none;

  &_page {
    width: 100%;
    height: calc(100% - 7rem);
    overflow: auto;
    padding: 0.8rem;
    background-color: #ffffff;

    .word-list {
      &_item {
        padding: 4vw;
        background-color: var(--page-bg-color);
        border-radius: 0.3rem;
        margin-bottom: 5vw;
        border: 1px solid transparent;
        position: relative;

        .item-word {
          flex: 1;
          width: 70%;
        }

        .item-icon {
          min-width: 25%;
          flex-shrink: 0;
          justify-content: flex-end;
        }

        .english-word {
          margin-right: 1rem;
        }

        .left-line {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translate(0, -50%);
          width: 0.8vw;
          height: 60%;
          border-radius: 0.5vw;
          background-color: var(--green-bg-color);
        }

        .word-style {
          // max-width: 70%;
          font-size: var(--font-20);
          word-break: break-all;
          align-items: center;
        }

        .test-icon {
          width: 2rem;
          height: 2rem;
          margin-top: 0.3rem;
          flex-shrink: 0;
          transition: transform 0.1s ease-in-out;

          &:active {
            transform: scaleY(0);
            transition: transform 0.1s ease-in-out;
          }
        }

        .img-icon {
          width: 2rem;
          margin-left: 3vw;
        }
      }

      &-hide {
        display: none !important;
      }

      .item-checked {
        border: 1px solid var(--green-bg-color);
      }
    }

    .statistic {
      color: var(--font-grey-color);
    }

    ion-button::part(native) {
      box-sizing: content-box;
      padding: 1vw 0;
    }
  }

  &-empty {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;

    &-tip {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-bottom: 8vh;

      &__title {
        color: #868f9e;
        font-size: 1rem;
        margin-bottom: 10px;
      }

      &__img {
        width: 25vw;
      }
    }

    .onlyNotNumClass {
      opacity: 0;
    }

    .notNumClass {
      margin-left: 10vw;
    }
  }

  .encourage-padding {
    width: 100%;
    height: 100%;
    padding: 0 5vw;

    .emoji {
      width: 90%;
      margin: 0 auto;
    }
  }

  &_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 7rem;
    background-color: #ffffff;
    box-shadow: 1px 1px 2px 0 var(--font-grey-color);

    &-content {
      height: 80%;
      padding: 2vh 3vw 0;
    }
  }

  &_box {
    position: relative;
    //width: 8vh;

    img {
      width: 4rem;
    }

    .box-text {
      position: absolute;
      left: 50%;
      top: 16%;
      transform: translate(-50%, -50%);
      font-weight: 600;
    }

    .true-text {
      color: #0bbb7d;
    }

    .false-text {
      color: #ff3142;
    }
  }
}
</style>
